import React from 'react';

import {connect} from "react-redux";
import Loader from "../common/Loader";
import sematable, {Table} from "sematable";
import {Button,NavItem} from "react-materialize";
import l10n from "../../l10n/localization";
import VesselForm from "../forms/VesselForm";
import * as vesselActions from "../../actions/vessel";
import * as creationActions from "../../actions/creation";
import Dropdown from "../common/Dropdown";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const VESSELS_TABLE = 'VESSELS_TABLE';

const columns = [
    { key: 'id', header: 'ID', primaryKey: true, hidden: true},
    { key: 'name', header: l10n.vessel.name, searchable: true, filterable: true, sortable: true},
    { key: 'year', header: l10n.vessel.year, searchable: true, filterable: true, sortable: true},
    { key: 'oldName', header: l10n.vessel.oldName, searchable: true, filterable: true, sortable: true},
    { key: 'actions', header: ''}
];

/**
 * Table
 */
class VesselsTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            vesselID: null,
            dialogActive: false
        };
    }

    handleDelete = () =>{
        this.props.dispatch(vesselActions.deleteVessel(this.state.vesselID));
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons commodities-button">
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deletingVessel} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, vesselID: row.id})} >
                                {l10n.common.remove}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                    <Button floating onClick={() => this.props.handleClick(VesselForm, {item: row}, creationActions.destroyingnewlyCreatedVessel())} icon="edit" className="edit-button" />
                </div>
            )
        };
    }

    render() {
        this.addActions();

        return (
            <div>
                <Table  {...this.props} data={this.props.data} />
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, vesselID: null}) },
                        { label: "Yes", onClick: () => this.handleDelete() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this vessel ?</p>
                </Dialog>
            </div>
        )
    }
}

let VesselsTableSematable = sematable(VESSELS_TABLE, VesselsTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});

/**
 * Wrapper
 */
class Vessels extends React.Component {

    componentDidMount() {
        this.props.dispatch(vesselActions.fetchVessels(true));
    }

    render() {
        if (this.props.loading || this.props.vessels === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <h1>{this.props.item.title}</h1>
                <Button type="button" floating onClick={() => this.props.handleClick(VesselForm, {item: null, selectNewItem: false}, creationActions.destroyingnewlyCreatedVessel())} icon="add" className="add-button"/>
                <VesselsTableSematable {...this.props} data={this.props.vessels} />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        vessels: state.vessel.vessels,
        loading: state.vessel.loading,
        deletingVessel: state.vessel.deleting
    });
})(Vessels);


// WEBPACK FOOTER //
// ./src/components/prefTables/Vessels.js